export default {
  HABITS_AVAILABLE_BUDGET_CALCULATION_REPOSITORY: Symbol.for('HABITS_AVAILABLE_BUDGET_CALCULATION_REPOSITORY'),
  CREATE_HABITS_AVAILABLE_BUDGET_CALCULATION_COMMAND: Symbol.for('CREATE_HABITS_AVAILABLE_BUDGET_CALCULATION_COMMAND'),
};
